import { useOrganizationsScreenContext } from "../../../../context/organizations/OrganizationsScreenContextProvider";
import ReadonlyOrganizationDetails from "./components/ReadonlyOrganizationDetails";

function OrganizationProfileMain() {
  const { selectedSideFilterOrganization } = useOrganizationsScreenContext();

  return (
    <div className="flex-1 min-h-0 bg-white p-1">
      <ReadonlyOrganizationDetails
        organization={selectedSideFilterOrganization!}
      />
    </div>
  );
}

export default OrganizationProfileMain;
